import { html } from 'htm/preact';
import { TextFieldEntry, TextAreaEntry, CheckboxEntry, isTextFieldEntryEdited } from '@bpmn-io/properties-panel';
import { useService } from 'bpmn-js-properties-panel';
import type { Element } from 'diagram-js/lib/model/Types';

interface CaseProps {
  element: Element;
  id: string;
  entry: any;
  description: string;
}

export default function caseProps(element: Element) {
  return [

    {
      id: 'code',
      element,
      component: Item,
      entry: TextFieldEntry,
      isEdited: isTextFieldEntryEdited,
      description: '',
    },
    {
      id: 'service',
      element,
      component: Item,
      entry: TextFieldEntry,
      isEdited: isTextFieldEntryEdited,
      description: '',
    },
     {
      id: 'type',
      element,
      component: Item,
      entry: TextFieldEntry,
      isEdited: isTextFieldEntryEdited,
      description: '',
    },
    {
      id: 'start',
      element,
      component: Item,
      entry: CheckboxEntry,
      isEdited: isTextFieldEntryEdited,
      description: '',
    },
    {
      id: 'form',
      element,
      entry: TextFieldEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      description: '',
    },
    {
      id: 'icon',
      element,
      entry: TextFieldEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      
      description: '',
    },
    {
      id: 'params',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'caseContext',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'input',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'output',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },

    {
      id: 'caseStatus',
      element,
      entry: TextFieldEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      description: '',
    },
    {
      id: 'caseOwner',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'codeTemplate',
      element,
      entry: TextFieldEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      description: '',
    },
    {
      id: 'actionParams',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'data',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'inputs',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'outputs',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'owner',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'group',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'startCondition',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'resume',
      element,
      component: Item,
      entry: CheckboxEntry,
      isEdited: isTextFieldEntryEdited,
      description: '',
    },
    {
      id: 'resumeCondition',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'dataTemplate',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'dueAtDuration',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
  ];
}

export function processActionsProps(element: Element) {
  return [

    {
      id: 'createdBy',
      element,
      entry: TextFieldEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      description: '',
    },
    {
      id: 'owner',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'roles',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'groups',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
  ];
}

export function processActivityActionsProps(element: Element) {
  return [


    {
      id: 'owner',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
     {
      id: 'group',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
     {
      id: 'caseOwner',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'caseCreatedBy',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'roles',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'groups',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
  ];
}

export function processFormsProps(element: Element) {
  return [

    {
      id: 'forms',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
  ];
}

export function processFormProps(element: Element) {
  return [


    {
      id: 'code',
      element,
      entry: TextFieldEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,

      description: '',
    },
     {
      id: 'readonly',
      element,
      entry: CheckboxEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      description: '',
    },
     {
      id: 'data',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
   
  ];
}

export function processViewProps(element: Element) {
  return [

    {
      id: 'form',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'logs',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'steps',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'relations',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
     {
      id: 'attachments',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
     {
      id: 'chronologie',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
  ];
}

export function processFilterCategoryProps(element: Element) {
  return [

    {
      id: 'code',
      element,
      entry: TextFieldEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
     
      description: '',
    },
    {
      id: 'condition',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
    {
      id: 'label',
      element,
      entry: TextFieldEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      
      description: '',
    },
    {
      id: 'rank',
      element,
      entry: TextFieldEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      
      description: '',
    },
    {
      id: 'icon',
      element,
      entry: TextFieldEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      
      description: '',
    },
    
  ];
}

export function processFiltersProps(element: Element) {
  return [

    {
      id: 'filters',
      element,
      entry: TextAreaEntry,
      component: Item,
      isEdited: isTextFieldEntryEdited,
      modelProperty: 'jsonData',
      description: 'Enter JSON data',
    },
  ];
}

function Item(props: CaseProps) {
  const { element, id, entry } = props;
  const modeling = useService('modeling');
  const translate = useService('translate');
  const debounce = useService('debounceInput');

  const getValue = (): string => {
    return element.businessObject[id] || '';
  };

  const setValue = (value: string) => {
    return modeling.updateProperties(element, {
      [id]: value
    });
  };

  return html`<${entry}
    id=${id}
    element=${element}
    description=''
    label=${translate(id.charAt(0).toUpperCase() + id.slice(1))}
    getValue=${getValue}
    setValue=${setValue}
    debounce=${debounce}
    tooltip=${translate(props.description)}
  />`;
}

